import script from "./hct-logistics.vue?vue&type=script&setup=true&lang=js"
export * from "./hct-logistics.vue?vue&type=script&setup=true&lang=js"

import "./hct-logistics.vue?vue&type=style&index=0&id=b1c8e916&scoped=true&lang=scss"

import exportComponent from "E:\\a-project\\hct-element\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b1c8e916"]])

export default __exports__